import {
  FLOATING_EXPANDABLE_BUBBLE_EDGE_ZONE_THRESHOLD,
  FLOATING_EXPANDABLE_BUBBLE_MARGIN,
  FLOATING_EXPANDABLE_BUBBLE_NAVBAR_WIDTH
} from "../constants";
import type { BubbleAxisAnchor, BubblePosition } from "../types";

type DropPositionOptions = {
  margin?: number;
  edgeZoneThreshold?: number;
  navbarWidth?: number;
};

const resolveAxis = (
  coord: number,
  size: number,
  startOffset: number,
  endOffset: number,
  edgeZoneThreshold: number
): BubbleAxisAnchor => {
  if (coord < size * edgeZoneThreshold) {
    return { type: "start", offset: startOffset };
  }
  if (coord > size * (1 - edgeZoneThreshold)) {
    return { type: "end", offset: endOffset };
  }
  return { type: "fraction", value: coord / size };
};

export const getDropPosition = (
  point: { x: number; y: number },
  viewport: { width: number; height: number },
  options: DropPositionOptions = {}
): BubblePosition => {
  const margin = options.margin ?? FLOATING_EXPANDABLE_BUBBLE_MARGIN;
  const edgeZoneThreshold = options.edgeZoneThreshold ?? FLOATING_EXPANDABLE_BUBBLE_EDGE_ZONE_THRESHOLD;
  const navbarWidth = options.navbarWidth ?? FLOATING_EXPANDABLE_BUBBLE_NAVBAR_WIDTH;

  return {
    horizontal: resolveAxis(point.x, viewport.width, margin + navbarWidth, margin, edgeZoneThreshold),
    vertical: resolveAxis(point.y, viewport.height, margin, margin, edgeZoneThreshold)
  };
};

export const isMagnetPosition = (position: BubblePosition): boolean =>
  position.horizontal.type !== "fraction" || position.vertical.type !== "fraction";

const anchorAtDrop = (
  final: BubbleAxisAnchor,
  coord: number,
  size: number,
  halfBubble: number
): BubbleAxisAnchor => {
  switch (final.type) {
    case "start":
      return { type: "start", offset: coord - halfBubble };
    case "end":
      return { type: "end", offset: size - coord - halfBubble };
    case "fraction":
      return { type: "fraction", value: coord / size };
  }
};

export const getDropAnchor = (
  final: BubblePosition,
  point: { x: number; y: number },
  viewport: { width: number; height: number },
  halfBubble: number
): BubblePosition => ({
  horizontal: anchorAtDrop(final.horizontal, point.x, viewport.width, halfBubble),
  vertical: anchorAtDrop(final.vertical, point.y, viewport.height, halfBubble)
});
